import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Check, X } from 'lucide-react';
import SEO from './SEO';
import PageHeader from './PageHeader';

const Features = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    { name: 'Sample Story Gallery', diy: true, pro: true, agency: true },
    { name: 'Easy Story Builder (Compiler)', diy: true, pro: true, agency: true },
    { name: 'HTML Export', diy: true, pro: true, agency: true },
    { name: 'Mind Map Export', diy: true, pro: true, agency: true },
    { name: 'Visual Editor', diy: false, pro: true, agency: true },
    { name: 'Visual Story Planner', diy: false, pro: true, agency: true },
    { name: 'Shared Story Sessions', diy: false, pro: true, agency: true },
    { name: 'PowerPoint Export', diy: false, pro: true, agency: true },
    { name: 'WordPress Block Export', diy: false, pro: true, agency: true },
    { name: 'WordPress Pack (ZIP)', diy: false, pro: true, agency: true },
    { name: 'Sitemap to PathNav', diy: false, pro: false, agency: true },
    { name: 'Customer Journey Wizard', diy: false, pro: false, agency: true },
    { name: 'PathNav Advanced Features', diy: false, pro: false, agency: true },
  ];

  const tiers = [
    { key: 'diy', name: 'DIY', color: 'bg-slate-500', desc: 'Free for hobbyists' },
    { key: 'pro', name: 'PRO', color: 'bg-purple-600', desc: 'For serious creators' },
    { key: 'agency', name: 'AGENCY', color: 'bg-amber-600', desc: 'For teams & clients' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <SEO title="Features - TweePorter" />
      
      <PageHeader />

      <div className="container mx-auto px-4 py-12">
        {/* Page headline */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Feature Comparison</h1>
          <p className="text-lg text-slate-600">Choose the tier that matches your needs</p>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Header */}
          <div className="grid grid-cols-4 gap-0 border-b border-slate-200">
            <div className="p-4 bg-slate-50">
              <span className="font-semibold text-slate-700">Features</span>
            </div>
            {tiers.map(tier => (
              <div key={tier.key} className="p-4 text-center">
                <span className={`inline-block px-3 py-1 ${tier.color} text-white text-sm font-bold rounded-full mb-1`}>
                  {tier.name}
                </span>
                <p className="text-xs text-slate-500">{tier.desc}</p>
              </div>
            ))}
          </div>

          {/* Feature rows */}
          {features.map((feature, idx) => (
            <div 
              key={idx} 
              className={`grid grid-cols-4 gap-0 border-b border-slate-100 ${idx % 2 === 0 ? 'bg-slate-50/50' : ''}`}
            >
              <div className="p-4 flex items-center">
                <span className="text-sm text-slate-700">{feature.name}</span>
              </div>
              {tiers.map(tier => (
                <div key={tier.key} className="p-4 flex items-center justify-center">
                  {feature[tier.key] ? (
                    <Check className="w-5 h-5 text-green-500" />
                  ) : (
                    <X className="w-5 h-5 text-slate-300" />
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* CTA buttons */}
        <div className="flex justify-center gap-4 mt-8">
          <Button onClick={() => navigate('/examples')} className="bg-slate-600 hover:bg-slate-700">
            Try DIY Free
          </Button>
          <Button onClick={() => navigate('/pro')} className="bg-purple-600 hover:bg-purple-700">
            Explore PRO
          </Button>
          <Button onClick={() => navigate('/agency')} className="bg-amber-600 hover:bg-amber-700">
            Agency Suite
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Features;
